<template>
  <div class="header-simple">
    <div class="header-wrapper">
        <button class="btn-back" @click="onClickBack()">
          <img :src="require('@/assets/img/ico_back.svg')" alt />
        </button>
      <h3 class="header-title">{{$t(pageTitle)}}</h3>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      default: ''
    },
    backTo: {
      type: String,
      default: 'Home'
    }
  },
  methods: {
    onClickBack () {
      this.$router.push({name: this.backTo})
    }
  }
};
</script>

<style scoped>
.header {
  width: 100%;
  background-position: 50%;
  background-color: #5DC1B7;
  padding: 22px 0;
  border-bottom: unset;
}
.icon-back {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate(0px, -50%);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/TitleHeader.vue